import { flow, flatten, isArray, map, reduce } from 'lodash/fp';

const DEFAULT_SORTING = [
  'vehicle',
  'prevOwner',
  'geoLocation',
  'distance',
  'priceRangeMin',
  'priceRangeMax',
  'monthlyPriceRangeMin',
  'monthlyPriceRangeMax',
  'mileageRangeMin',
  'mileageRangeMax',
  'powerRangeMin',
  'powerRangeMax',
  'yearRangeMin',
  'yearRangeMax',
  'fuelType',
  'transmission',
  'sellerType',
  'bodyType',
  'comfort',
  'seatComfort',
  'seats',
  'doors',
  'consumption',
  'emissionSticker',
  'envStandard',
  'metallic',
  'color',
  'airbag',
  'security',
  'light',
  'multimedia',
  'interior',
  'parkingSensors',
  'extras',
  'upholstery',
  'serviceHistory',
  'notDamaged',
  'hasImages',
  'smoker',
];

const toSort = (filtersForm, sorting = DEFAULT_SORTING) =>
  reduce(
    (acc, key) => {
      const filters = filtersForm[key];

      if (filters) {
        if (isArray(filters)) {
          return [...acc, ...map((item) => ({ ...item, key }), filters)];
        }

        return [...acc, { ...filters, key }];
      }

      return acc;
    },
    [],
    sorting,
  );

export default flow(toSort, flatten);
